module.exports = __webpack_public_path__ + "img/logo.60fc1c11.svg";